import React from 'react';

const Close = (props) => {
  return (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      width='12'
      height='11'
      viewBox='0 0 12 11'
      fill='none'
      {...props}
    >
      <path
        d='M2.27918 0.219846C2.137 0.0873663 1.94896 0.0152433 1.75465 0.0186715C1.56035 0.0220998 1.37497 0.100812 1.23755 0.238225C1.10014 0.375638 1.02143 0.561023 1.018 0.755324C1.01457 0.949625 1.0867 1.13767 1.21918 1.27985L4.93918 4.99985L1.21918 8.71985C1.14549 8.78851 1.08639 8.87131 1.0454 8.96331C1.0044 9.05531 0.982362 9.15462 0.980585 9.25532C0.978809 9.35603 0.997333 9.45606 1.03505 9.54944C1.07278 9.64283 1.12892 9.72767 1.20014 9.79888C1.27136 9.8701 1.35619 9.92625 1.44958 9.96397C1.54297 10.0017 1.643 10.0202 1.7437 10.0184C1.8444 10.0167 1.94372 9.99462 2.03571 9.95363C2.12771 9.91264 2.21052 9.85353 2.27918 9.77985L5.99918 6.05985L9.71918 9.77985C9.78784 9.85353 9.87064 9.91264 9.96264 9.95363C10.0546 9.99462 10.154 10.0167 10.2547 10.0184C10.3554 10.0202 10.4554 10.0017 10.5488 9.96397C10.6422 9.92625 10.727 9.8701 10.7982 9.79888C10.8694 9.72767 10.9256 9.64283 10.9633 9.54944C11.001 9.45606 11.0195 9.35603 11.0178 9.25532C11.016 9.15462 10.9939 9.05531 10.953 8.96331C10.912 8.87131 10.8529 8.78851 10.7792 8.71985L7.05918 4.99985L10.7792 1.27985C10.9117 1.13767 10.9838 0.949625 10.9804 0.755324C10.9769 0.561023 10.8982 0.375638 10.7608 0.238225C10.6234 0.100812 10.438 0.0220998 10.2437 0.0186715C10.0494 0.0152433 9.86135 0.0873663 9.71918 0.219846L5.99918 3.93985L2.27918 0.219846Z'
        fill='black'
      />
    </svg>
  );
};

export default Close;
